import React, {useState} from 'react'
import FormPaymentMethod from '../form/FormPaymentMethod'
import {IDialog} from './ModalPaymentMethodForm'
import Modal from 'react-bootstrap/Modal'
import {Button, Form} from 'react-bootstrap'
import {numberFormat} from '../../utils/Functions'
import {updateIncomeDocument} from '../../api/RevenueApi'
import {IncomeDocumentStateTypes, IncomeDocumentTypes} from '../../constants/Common'
import {useNavigate} from 'react-router-dom'
import toast from 'react-hot-toast'
import {truncateToTwoDecimals} from '../../utils/Helper'
import {paymentFeeSettlementAmount} from '../../utils/paymentEvent'
import {invoiceReceiptAmounts} from '../../utils/invoiceReceiptAmounts'

interface IModalOutstandingPayment extends IDialog {
  document: {[key: string]: any}
}

const ModalOutstandingPayment: React.FC<IModalOutstandingPayment> = (props) => {
  const { document } = props
  const navigate = useNavigate()
  const [form, setForm] = useState<any>({})
  const payments = (document.incomeDocumentPayments || []).filter(
    (payment: any) => !payment?.cancelledAt && !payment?.cancelled_at
  )
  const billingHistories = document.billingHistories || []
  const currentPayments = form?.incomeDocumentPayments || []
  const currentPaymentFees = form?.incomeDocumentPaymentFees || []
  const currentPaymentDeductions = form?.incomeDocumentPaymentDeductions || []
  const billingAlreadyPaidTotal = billingHistories.reduce((sum: number, item: any) => {
    if (item?.incomeDocument?.state !== IncomeDocumentStateTypes.PAID) {
      return sum
    }

    return sum + truncateToTwoDecimals(item?.billingAmount || 0)
  }, 0)
  const invoiceAmounts = invoiceReceiptAmounts(document)
  const isInvoice = document.type === IncomeDocumentTypes.INVOICE
  // ใช้ยอดเต็มเพื่อตัด payment.amount + WHT และใช้ยอดสุทธิแสดงให้ผู้รับเงินเห็น
  const baseAmount = truncateToTwoDecimals(
    isInvoice ? invoiceAmounts.grossAmount : (document.netAmount ?? document.totalAmount ?? 0)
  ) - billingAlreadyPaidTotal
  let remainingAmount = baseAmount
  let maximumPayingAmount = (isInvoice ? invoiceAmounts.settlementAmount : baseAmount)

  if (payments?.length) {
    payments.map((item: any) => {
      remainingAmount = remainingAmount - truncateToTwoDecimals(item?.amount) - truncateToTwoDecimals(item?.whTaxPrice)
      maximumPayingAmount = maximumPayingAmount - truncateToTwoDecimals(item?.amount)
    })
  }

  const settledByExistingFees = paymentFeeSettlementAmount(document.incomeDocumentPaymentFees || [])
  remainingAmount -= settledByExistingFees
  maximumPayingAmount -= settledByExistingFees

  // FormPaymentMethod ใช้ totalAmount เป็นฐานตั้งยอดชำระและ WHT ของแถวใหม่
  // ค่านี้ต้องหักเฉพาะรายการที่บันทึกแล้วเท่านั้น ห้ามหักค่าที่กำลังกรอกใน modal
  // ไม่เช่นนั้น parent จะส่งยอดลดลงกลับไปให้ form ทุกครั้งที่เลือกช่องทางชำระ
  // แล้วเกิดวงจร reset ยอดชำระไปมา
  const paymentFormTotalAmount = remainingAmount

  if (currentPayments?.length && currentPayments?.[0] !== undefined) {
    currentPayments.map((item: any) => {
      const amount = truncateToTwoDecimals(item?.amount || 0)
      const whTaxPrice = truncateToTwoDecimals(item?.whTaxPrice || 0)

      remainingAmount = remainingAmount - (amount + whTaxPrice)
    })
  }

  const handleSubmit = (e: any) => {
    e.preventDefault()

    let formRemainingAmount = remainingAmount
    if (form.incomeDocumentPayments.length) {
      form.incomeDocumentPayments.map((item: any) => {
        formRemainingAmount = remainingAmount - item?.amount
      })
    }

    let _form = {...form}
    const totalFees = currentPaymentFees.reduce((a: any, b: any) => a + (b.reason === 1 ? Number(b.amount) : Number(b.amount) * -1), 0)
    let totalDeductions = currentPaymentDeductions.reduce((a: any, b: any) => {
      if (b.type === 'credit') {
        return a + b.amount
      }

      return a - b.amount
    }, 0)

    console.log(_form)

    // NOTE:: แปลงเลขติดลบให้เอาเข้ามาเป็น +
    // ถ้าเจ๊งแจ้งโอ็คได้เลยครับ อาจจะต้องหาท่าอื่น กลัวกระทบ
    totalDeductions = Math.abs(totalDeductions)
    const remainingAmountResolved = remainingAmount + truncateToTwoDecimals(totalFees) - truncateToTwoDecimals(totalDeductions)
    if (remainingAmountResolved <= 0) {
      _form = {
        ..._form,
        state: document.type === IncomeDocumentTypes.DEPOSIT
          ? IncomeDocumentStateTypes.AWAIT_DEDUCT
          : IncomeDocumentStateTypes.PAID,
      }
    }

    if (document.type === IncomeDocumentTypes.BILLING && (remainingAmountResolved !== 0)) {
      return toast.error('ไม่สามารถชำระเงินบางส่วนหรือติดลบได้')
    }

    updateIncomeDocument(
      document.id,
      _form,
      (res: any) => {
        if (_form.incomeDocumentPaymentDeductions) {
          _form.incomeDocumentPaymentDeductions.map((paymentDeduction: any) => {
            updateIncomeDocument(
              paymentDeduction.incomeDocumentId,
              {state: IncomeDocumentStateTypes.DEDUCTED},
              (res: any) => {
                console.log(res)
              }
            )

            return
          })
        }

        if (remainingAmountResolved <= 0) {
          props.onSubmitSuccess(res)
          return
        }

        navigate(0)
      }
    )
  }

  return (
    <Modal size={'lg'} show={props.show} onHide={() => props.onClose()}>
      <Modal.Header closeButton className={'flex-column py-2 align-items-start'}>
        <Modal.Title>รับชำระเงิน #{document.code}</Modal.Title>
        <div className={'fs-5'}>มูลค่าลูกหนี้ที่สามารถรับชำระได้ทั้งสิ้น <strong>{numberFormat(maximumPayingAmount)}</strong> บาท</div>
      </Modal.Header>
      <Modal.Body className={'p-2'}>
        <Form onSubmit={handleSubmit}>
          <FormPaymentMethod
            isPaying
            disableTitle
            documentId={document.id}
            currentDocument={document}
            remainingAmount={remainingAmount}
            totalAmount={paymentFormTotalAmount}
            currentDocumentFormItems={props.document.incomeDocumentItems}
            onFormChange={(data) => {
              setForm({...form, ...data})
            }}
            onCreatingMethod={() => {}}
          />
          <div className={'text-end mt-8'}>
            <Button disabled={!form.incomeDocumentPayments?.length} type={'submit'} variant={'info'}>{'รับชำระเงิน'}</Button>
            <Button variant={'secondary'} className={'ms-2'} onClick={props.onClose}>{'ปิด'}</Button>
          </div>
        </Form>
      </Modal.Body>
    </Modal>
  )
}

export default ModalOutstandingPayment
